import React, { useState } from 'react';

const InstagramInput = ({ onSubmit, onBack }) => {
    const [username, setUsername] = useState('');
    const [error, setError] = useState('');

    const handleSubmit = (e) => {
        e.preventDefault();

        // Remove @ if user added it
        const cleanUsername = username.trim().replace('@', '');

        // Validation
        if (cleanUsername.length < 3) {
            setError('Kullanıcı adı en az 3 karakter olmalı');
            return;
        }

        if (cleanUsername.length > 30) {
            setError('Kullanıcı adı en fazla 30 karakter olabilir');
            return;
        }

        if (!/^[a-zA-Z0-9._]+$/.test(cleanUsername)) {
            setError('Sadece harf, rakam, nokta ve alt çizgi kullanabilirsiniz');
            return;
        }

        onSubmit(cleanUsername);
    };

    const handleChange = (e) => {
        setUsername(e.target.value);
        setError('');
    };

    return (
        <div className="instagram-input">
            <h2>📱 Instagram Kullanıcı Adın</h2>
            <p className="subtitle">Kazanırsan sana ulaşabilmemiz için gerekli</p>

            <form onSubmit={handleSubmit} className="instagram-form">
                <div className="input-wrapper">
                    <span className="at-symbol">@</span>
                    <input
                        type="text"
                        value={username}
                        onChange={handleChange}
                        placeholder="kullaniciadin"
                        maxLength={30}
                        autoFocus
                        className="neon-input"
                    />
                </div>

                {error && <div className="input-error">{error}</div>}

                <div className="instagram-info">
                    <p>💡 <strong>Neden gerekli?</strong></p>
                    <ul>
                        <li>Kazanırsan sana DM'den ulaşacağız</li>
                        <li>Liderlik tablosunda görünecek</li>
                        <li>Günde 1 kez oynama hakkın var</li>
                    </ul>
                </div>

                <div className="button-group">
                    <button type="submit" className="neon-btn primary">
                        ✅ Devam Et
                    </button>
                    <button type="button" className="neon-btn secondary" onClick={onBack}>
                        ← Geri Dön
                    </button>
                </div>
            </form>
        </div>
    );
};

export default InstagramInput;
